import React, { useEffect } from "react";
import styled from "styled-components"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"

import colors from "../settings/colors"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Questions = styled.div`
  padding-bottom: 75px;
`
const Question = styled.div`
  display: flex;
  margin-bottom: 10px;

  h3 {
    margin: 0px;
  }

  > div:nth-child(1) {
    background-color: ${colors.orange};
    color: white;
    padding: 25px;
  }
  > div:nth-child(2) {
    padding: 15px;
  }
`

function FaqPage(props) {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/faq", title: "FAQ"});
  }, []);

  const questions = [
    {
      question: "How can I get tickets to an individual show?",
      answer: "Show tickets may be purchased by phone at (304) 696-6656 with all major credit cards, or in person weekdays from 12:00 p.m. to 4 p.m. in our box office in the Joan C. Edwards Performing Arts Center. You may also order tickets online at Ticketmaster.com. When available, tickets are sold at the door on event nights beginning one hour prior to the performance. We cannot hold tickets without payment."
    },
    {
      question: "May I take photographs or video record the event?",
      answer: "No. The artists request that no photographs or video equipment be permitted."
    },
    {
      question: "Is there a group discount?",
      answer: "Yes, a 10% discount is given to groups of 20 or more."
    },
    {
      question: "What style of dress is appropriate?",
      answer: "Everyone is welcome regardless of attire. Most patrons wear a casual business style."
    },
    {
      question: "May I receive a refund if I can't go?",
      answer: "No, like any ticket office, we cannot make refunds. If you return your tickets to us before show time, we'll give you a tax receipt for the full ticket value."
    },
    {
      question: "How do Marshall students obtain tickets?",
      answer: "Visit our box office on campus in the Joan C. Edwards Performing Arts Center, located on 5th Avenue, across from the student center. Box office hours are Monday – Friday, noon to 4 p.m. Valid MUID is required for all box office transactions and for show admission."
    },
    {
      question: "May my children attend?",
      answer: "Yes, we encourage parents to expose their children to the arts. However, we do advise parental discretion. Some shows are not always recommended for younger audience members."
    },
    {
      question: "Does the Keith-Albee Performing Arts Center have an elevator?",
      answer: "No, unfortunately, there is not an elevator in the Keith-Albee Performing Arts Center."
    },
    {
      question: "Does the Joan C. Edwards Performing Arts Center have an elevator?",
      answer: "Yes, there is an elevator."
    },
    {
      question: "Are handicap seats available?",
      answer: "Handicap seating is available in all price ranges.  Call 304-696-3326 for assistance."
    }
  ]

  return (
    <Layout page="faq" title="FAQ">
      <Container>
        <PageHeader>Frequently Asked Questions</PageHeader>
      </Container>
      <Container>
        <Questions>
        {questions.map((question, index) => (
            <Question>
              <div>
                <FontAwesomeIcon icon={faQuestionCircle} size="3x" />
              </div>
              <div>
                <h3>{question.question}</h3>
                <p>{question.answer}</p>
              </div>
            </Question>
        ))}
        </Questions>
      </Container>      
    </Layout>
  );
}

export default FaqPage;